<template>
    <li>
        <span v-bind:class="{'level1 ': true,
                              'button': true,
                              'switch':true,
                              'noline_open': treeData.children && treeData.isExpand,
                              'noline_close': treeData.children && !treeData.isExpand,
                              'center_docu':!treeData.children && !treeData.isLastNode,
                              'bottom_docu':!treeData.children && treeData.isLastNode}"
              @click="changeExpand(treeData)">
        </span>
        <a class="level1"
           v-bind:class="{'level1 ': true,'curSelectedNode': treeData.isSelected}"
           @click="selectNode(treeData)">
            <!-- <span v-bind:class="{'ico_open': treeData.children,
                                    'ico_docu':treeData.children == null || treeData.children.length == 0,
                                    'button':true}">
            </span> -->
            <span class="org-icon">
                <zx-icon :type="treeData.level < 3 ? 'icon-jigou' : 'icon-organize'"></zx-icon>
            </span>
            <span class="node_name" id="treeDemo_9_span">{{treeData.name}}</span>
        </a>

        <span v-if="treeData.isSelected && getLevel(treeData.link) < 7"
              class="button add"
              style="background-position: -144px 0;vertical-align: top;"
              id="treeDemo_3_add"
              @click="onAddNode(treeData)"
              :title="$t('global.create')">
        </span>

        <a-popconfirm :title="treeData.level == 2 ? $t('global.confirm') : $t('global.confirm') " @confirm="onDeleteNode(treeData)" :okText="$t('global.yes')" :cancelText="$t('global.no')">
            <!-- <span v-if="treeData.isSelected && treeData.parentName" class="button remove" title="删除"></span> -->
            <!-- 替换删除按钮的图标 -->
            <span class="zx-icon" :title="$t('global.delete')">
                <zx-icon v-if="treeData.isSelected && treeData.pid" type="icon-shanchu1" />
            </span>
        </a-popconfirm>

        <a-popconfirm :title="treeData.level == 2 ? $t('global.confirm') : $t('global.confirm') " @confirm="onDownload(treeData)" :okText="$t('global.yes')" :cancelText="$t('global.no')">
            <!-- <span v-if="treeData.isSelected && treeData.parentName" class="button remove" title="删除"></span> -->
            <!-- 替换删除按钮的图标 -->
            <span class="zx-icon" title="导出机构数据" >
                <zx-icon v-if="treeData.isSelected && isSuperAdmin" type="icon-daochu" />
            </span>
        </a-popconfirm>

        <span v-if="treeData.isSelected && isSuperAdmin"  class="zx-icon" title="导入机构数据" >
            <zx-icon @click="importOrgData(treeData)" type="icon-fanhui" />
            <!-- <input @change="importOrgData"  style="" type="file"> -->
        </span>

        <ul v-if="treeData.children && treeData.isExpand "
            v-bind:class="{'line': treeData.isLastNode == false,
                             'level1':true}"
            style="display:block">
            <z-org-tree-item v-for="item in treeData.children" :treeData="item" :key="item.id"
                             @addNode="onAddNode"
                             @deleteNode="onDeleteNode"
                             @selectNode="onSelectNode">
            </z-org-tree-item>
        </ul>
    </li>

</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        name: "ZOrgTreeItem",
        components: {
        },
        data: function () {
            return {}
        },
        props: ['treeData'],
        computed: {
            ...mapGetters([
                'isSuperAdmin','isIntegrator'
            ])
        },
        methods: {
            onDownload (data) {
                // console.log(data)
                const id = data.id
                this.$http.get(`/api/org/v1.0/orgsExport/${id}`).then((res) => {
                    // console.log(res)
                    const { code, result, desc } = res
                    if (code === 0) {
                        const file = new File([JSON.stringify(result)], 'org', {type: 'application/json'})
                        const fd = new FileReader()
                        fd.readAsDataURL(file)
                        fd.onload = (ev) => {
                            // console.log(ev)
                            const a = document.createElement('a')
                            a.href = ev.target.result
                            a.download = 'org.json'
                            a.click()
                            a.remove()
                            a = null
                        }
                    } else {
                        this.$notification.error({
                            message: desc
                        })
                    }
                })
            },
            importOrgData (data) {
                // console.log(data)
                const id = data.id
                const input = document.createElement('input')
                input.type = 'file'
                input.removeAttribute('readOnly')
                input.addEventListener('change', ev => {
                    // console.log(ev)
                    // console.log(input.files)
                    const file = input.files[0]
                    const fd = new FileReader()
                    fd.readAsText(file)
                    fd.onload = (ev) => {
                        // console.log(fd)
                        const param = fd.result
                        this.$http.post('/api/org/v1.0/orgsImport', {
                            orgId: id,
                            data: JSON.parse(param)
                        }).then((res) => {
                            console.log(res)
                            const { code, result, desc } = res
                            if (code === 0) {
                                const file = new File([JSON.stringify(result)], 'added-org', {type: 'application/json'})
                                const fd = new FileReader()
                                fd.readAsDataURL(file)
                                fd.onload = (ev) => {
                                    // console.log(ev)
                                    const a = document.createElement('a')
                                    a.href = ev.target.result
                                    a.download = 'added-org.json'
                                    a.click()
                                    a.remove()
                                    a = null
                                }
                            } else {
                                this.$notification.error({
                                    message: desc
                                })
                            }
                        })
                    }
                })
                input.click()
                input.remove()
                input = null
            },
            getLevel(link){
                if(link.split){
                    return link.split(',').length - 1
                }
            },
            changeExpand(node) {
                node.isExpand = !node.isExpand;
            },
            selectNode(node) {
                this.$emit('selectNode', node);
            },
            onSelectNode(node) {
                this.$emit('selectNode', node);
            },
            addNode(node){
                this.$emit('addNode', node);
            },
            onAddNode(node){
                this.$emit('addNode', node);
            },
            deleteNode(node){
                this.$emit('deleteNode', node);
            },
            onDeleteNode(node){
                this.$emit('deleteNode', node);
            }
        },
        created() {

        },
        mounted () {
          // console.log('item-mounted')
        }
        // isSuperAdminOrg (roles) {
        //     return !!(roles && roles.split(",").indexOf("SuperAdmin") != -1)
        // },
        // isIntegratorOrg (roles) {
        //     return !!(roles && roles.split(",").indexOf("Integrator") != -1)
        // },
        // isTopOrg (roles) {
        //     return !!(roles && roles.split(",").indexOf("TopOrg") != -1)
        // },
        // isOrg (roles) {
        //     return !!(roles && roles.split(",").indexOf("Org") != -1)
        // }
    }
</script>
<style lang="less" scoped>
.curSelectedNode {
    color: aquamarine;
    // background-color: #eee;
}
.org-icon {
    font-size: 20px;
    // color: rgb(82, 10, 124);
}
.zx-icon {
    font-size: 18px;
    cursor: pointer;
    color: rgb(187, 24, 24);
}
</style>
